<div class="dropdown-container">
  @if (selectedItem) {
    <div class="dropdown" ngClass="{{ toggled ? 'dropdown--toggled' : '' }}" #myInput>
      <div class="input-bar"
        (click)="toggle()"
        tabindex="0"
        (keydown.enter)="toggle()"
        (keydown.space)="toggle()"
        >
        <div class="label">
          @if (selectedItem.translate) {
            {{ selectedItem.label | translate }}
          } @else {
            {{ translateShowAll(selectedItem) }}
          }
        </div>
        <svg-icon src="assets/icons/chevron-down.svg" [svgStyle]="{ 'width.px':18, 'transform': toggled ? 'rotate(180deg)' : '' }"></svg-icon>
      </div>
      <div class="list" ngClass="{{ toggled ? 'list--toggled' : '' }}" data-cy="dropdown-choices">
        @if (availableList && availableList.length === 1) {
          <div class="no-data-available">
            {{ 'global.error.noData' | translate }}
          </div>
        } @else {
          @for (listItem of availableList; track listItem) {
            @if (listItem.value !== selectedItem.value) {
              <div
                class="list-item"
                (click)="selectItem(listItem)"
                data-cy="dropdown-list-item"
                tabindex="0"
                (keydown.enter)="selectItem(listItem)"
                (keydown.space)="selectItem(listItem)"
                >
                @if (listItem.translate) {
                  {{ listItem.label | translate }}
                } @else {
                  {{ translateShowAll(listItem) }}
                }
              </div>
            }
          }
        }
      </div>
    </div>
  }
</div>
